function stringifyAuthLogValue(value: unknown): string {
  if (value instanceof Error) return value.message;
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

export function redactAuthLogValue(value: unknown): string {
  return stringifyAuthLogValue(value)
    .replace(/\bGOCSPX-[A-Za-z0-9_-]+\b/g, "<redacted>")
    .replace(/([a-z][a-z0-9+.-]*:\/\/)([^:/@\s]+):([^/@\s]+)@/gi, "$1<redacted>:<redacted>@")
    .replace(/\b(bearer)\s+[a-z0-9._~+/=-]+/gi, "$1 <redacted>")
    .replace(
      /([?&](?:code|state|token|sessionToken|session_token|access_token|refresh_token|id_token|client_secret|inviteReservation|reservation)=)[^&#\s]+/gi,
      "$1<redacted>",
    )
    .replace(
      /\b([a-z0-9_]*(?:token|secret|password|passwd|pwd|api[_-]?key|session[_-]?token|exchange[_-]?code|oauth[_-]?code|state|client[_-]?secret|invite[_-]?reservation|reservation|code)[a-z0-9_]*)\s*[:=]\s*("[^"]*"|'[^']*'|[^\s,;]+)/gi,
      "$1=<redacted>",
    );
}
